// removed by extract-text-webpack-plugin
module.exports = {"list":"status-list-component__list___193hM","divider":"status-list-component__divider___2pqyZ","list_item":"status-list-component__list_item___2JFH4","list_item_section":"status-list-component__list_item_section___16Dwj","title":"status-list-component__title___3t3Eo","status":"status-list-component__status___oLxcR","dateTime":"status-list-component__dateTime___1xIaF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/status-list-component/status-list-component.scss
// module id = 613
// module chunks = 0